import {Menu} from './Menu';

export class MenuItem {

    /**
     * @param {HTMLLIElement} element
     * @param {Menu} menu
     */
    constructor(element, menu) {
        this.element = element;
        this.anchor = this.element.children[0];
        this.subMenu = new Menu(this.element.children[1], menu.depth + 1);
        this.menu = menu;

        this.anchor.addEventListener('click', event => {
            event.stopPropagation();
            if (this.subMenu.isEmpty()) {
                return;
            }
            event.preventDefault();
            this.subMenu.visible = !this.subMenu.visible;
            this.siblings().forEach(menuItem => menuItem.subMenu.visible = false);
        });
    }

    /**
     * @return {MenuItem[]}
     */
    siblings() {
        return this.menu.items.filter(menuItem => menuItem !== this);
    }

}
